<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">
          <div class="settings-header">
            FINANCE / Bank Accounts

            <div class="settings-header__btn" style="display: flex; align-items: center; gap: 20px">
              <el-dropdown size="mini">
              <span class="el-dropdown-link">
                Report Action<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item icon="el-icon-printer" @click.native="exportData(2, 25)">PDF</el-dropdown-item>
                  <el-dropdown-item icon="fas fa-file-excel" @click.native="exportData(1, 25)">XL
                  </el-dropdown-item>
                  <el-dropdown-item icon="el-icon-s-promotion" @click.native="exportData(3,25)">Email</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-button type="success" size="mini" @click="openTransactionModal('all')">All Transaction</el-button>
            </div>
          </div>
          <el-table
              max-height="600"
              size="mini"
              :data="tableData"
              :empty-text="$t('general_noData')"
              style="width: 100%"
              @row-click="rowClick"
              :header-cell-class-name="headerCellClassName"
              @cell-click="cellClick">
            <el-table-column
                align="center"
                column-key="fromTF"
                label="Chart of Accounts (CoA)">
              <el-table-column
                  width="100"
                  align="center"
                  column-key="fromTF"
                  prop="code"
                  label="DB Code">
                <template slot-scope="scope">
                  <div>
                    {{scope.row.code}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  column-key="fromTF"
                  class-name="sub-accounts"
                  prop="name"
                  label="Sub-accounts">
                <template slot-scope="scope">
                  <span style="color: #409EFF;">
                    {{scope.row.name}}
                  </span>
                </template>
              </el-table-column>
              <el-table-column
                  column-key="fromTF"
                  class-name="sub-accounts"
                  label="Status">
                <template slot-scope="scope">
                  <span style="color: #409EFF;">
                    {{scope.row.close ? 'Closed' : scope.row.active ? 'Active' : 'Inactive' }}
                  </span>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
                column-key="fromBank"
                align="center"
                label="From the Banks">
              <el-table-column
                  align="center"
                  column-key="fromBank"
                  width="200"
                  prop="bankAccount.accountNumber"
                  label="Account Number">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{scope.row.bankAccount.accountNumber}}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  column-key="fromBank"
                  width="150"
                  align="center"
                  label="Overdraft Limit">
                <template slot-scope="scope">
                  <div style="text-align: right;" class="number">{{scope.row.bankAccount ? formatPrice(scope.row.bankAccount.overDraftLimit) : formatPrice(0)}}</div>
                </template>
              </el-table-column>
              <el-table-column
                  column-key="fromBank"
                  align="center"
                  width="100"
                  prop="currencycode"
                  label="Currency">
              </el-table-column>
              <el-table-column
                  column-key="fromBank"
                  width="150"
                  label="Banks Balance (Cr)">
              </el-table-column>
            </el-table-column>
            <el-table-column
                align="center"
                column-key="fromTF"
                label="Reconciliation">
              <el-table-column
                  column-key="fromTF"
                  align="center"
                  width="150"
                  label="Out of Balance">
                <template slot-scope="scope">
                  <div style="text-align: right;" class="number">{{scope.row.outOfBalance ? formatPrice(scope.row.outOfBalance) : formatPrice(0)}}</div>
                </template>
              </el-table-column>
            </el-table-column>
            <el-table-column
                align="center"
                column-key="fromTF"
                label="General Ledger (GL)">
              <el-table-column
                  column-key="fromTF"
                  class-name="current-balance"
                  align="center"
                  width="170"
                  label="Current Balance (Dr)">
                <template slot-scope="scope">
                  <div class="number" style="color: #409EFF; text-align: right;">{{scope.row.currentBalance ? formatPrice(scope.row.currentBalance) : formatPrice(0)}}</div>
                </template>
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <settings-bank-account-info-modal ref="settingBankAccountInfoModal"/>
    <bank-account-transaction-modal ref="bankAccountTransactionModal"/>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import BankAccountTransactionModal from "../../../components/settings/settingsBankAccounts/BankAccountTransactionModal";
import SettingsBankAccountInfoModal
  from "../../../components/settings/settingsBankAccounts/settingsBankAccountInfoModal";

export default {
  name: "FinanceBankAccounts",
  components: {SettingsBankAccountInfoModal, BankAccountTransactionModal},
  computed: {
    companyLayout () {
      return this.$store.getters.getCompanyLayout
    },
    financialYearStartDateFormatted () {
      return this.companyLayout && this.companyLayout.financialYearStartDate ? moment(this.companyLayout.financialYearStartDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : null
    },
  },
  data(){
    return {
      tableData: [],
      moment: moment
    }
  },
  mounted(){
    this.loadList()
  },
  methods: {
    loadList() {
      let loader = this.$loading.show();
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
      axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
      axios
          .get(`/api/v1/account/accountOnlyBank?companyId=${this.$route.query.companyId}`)
          .then(response => {
            this.tableData = response.data.list
            loader.hide()
          })
          .catch(error => {
            loader.hide()
            console.log('An error occurred:', error);
          });
    },
    rowClick(row, column, event) {
      console.log('row, column, event', row, column, event)
    },
    cellClick(row, column, event){
      if (column.label === 'Current Balance (Dr)') {
        this.$refs.bankAccountTransactionModal.openModal(row)
      } else if (column.label === 'Sub-accounts') {
        this.$refs.settingBankAccountInfoModal.openModal(row)
      }
    },
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    openTransactionModal() {
      this.$refs.bankAccountTransactionModal.openModal()
    },
    headerCellClassName({row, column, rowIndex, columnIndex}) {
      console.log('{row, column, rowIndex, columnIndex}', {row, column, rowIndex, columnIndex})
      return column.columnKey
    },
    async exportData (typeExportId, typeId) {
      let email = null
      try {

        if (typeExportId === 3) {
          const { value } = await this.$prompt('Please input your e-mail', '', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            inputPattern: /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/,
            inputErrorMessage: 'Invalid Email'
          })
          email = value
        }
        const payload = {
          companyId: +this.$route.query.companyId,
          typeId: typeId,
          typeExportId: typeExportId,
          startDate: this.financialYearStartDateFormatted ? this.financialYearStartDateFormatted : '2022-01-01',
          endDate: moment().format('YYYY-MM-DD'),
          email: email,
          optionalField: {
            name: null,
            value: null
          }
        }
        let loader = this.$loading.show()
        axios.defaults.headers.common['Authorization'] =
            'Bearer ' + sessionStorage.getItem('token')
        axios.defaults.headers.common['X-Timezone-Offset'] = (
            new Date().getTimezoneOffset() / 60
        ).toString()
        const { data } = await axios.post(`/api/v1/export`, payload)
        switch (typeExportId) {
          case 2: // pdf
          case 1: // xl
            window.open(data.file.downloadPath).focus()
            break
        }
        loader.hide()
      } catch (err) {
        console.log(err)
      }
    },
  }
}
</script>

<style lang="less" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
      .settings-header {
        display: flex;
        justify-content: space-between;
      }
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}

/deep/.current-balance {
  cursor: pointer !important;
}

/deep/.sub-accounts {
  cursor: pointer !important;
}

/deep/.fromTF {
  background: #e7adb7 !important;
  color: black;
}

/deep/.fromBank {
  background: #adc4e7 !important;
  color: black;
}

</style>
